import { HISTORY_TYPE, IHistoryStep, ILandingSection, SECTION_DESIGN_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { useComposition } from "src/modules/pe-landing-module/hooks/useComposition"
import { ProportionEnabled } from "src/modules/pe-landing-module/widgets/composite/ProportionScalar"
import updateSection from "./utils/updateSection"

/* Protopia Ecosystem component */
export interface IProportiaHandlerProps {
    section: ILandingSection
    i: number
}
const ProportiaHandler = (props: IProportiaHandlerProps): JSX.Element => {
    const composition       = useComposition(props.section)

    const onProportiaChange = (value: number[], field: string, dop: any="") => {            
            console.log( value, field )
            const counts            = value.length
            const prevData          = JSON.parse( JSON.stringify( props.section ) )
            const newSection: any   = { 
                ...props.section, 
                composition: {
                    ...composition,
                    columns: counts,
                    proportia: value
                }
            } 
            const historyStep: IHistoryStep = {
                data:  newSection,
                prevData,
                type: HISTORY_TYPE.SECTION,
                title : "Change section's proportia",
            }
            updateSection(newSection, historyStep) 
        }

    return [ SECTION_DESIGN_TYPE.COLUMN ].includes( props.section.designType  || SECTION_DESIGN_TYPE.FEED )
        ?
        <div className='position-absolute left z-index-100 w-100 pe-surface' style={{ bottom: -45 }}>
        <ProportionEnabled
                editable
                dataSection="Section"
                dataName="proportia"
                type={ "" }
                columns={composition.columns}
                value={ composition.proportia }
                onChange={onProportiaChange}
            />
        </div>
        : 
        <></>
}
export default ProportiaHandler